import React from 'react';
import { styled, useTheme } from "@mui/material/styles";
import {
  Box,
  Card,
  List,
  ListItem,
  Typography,
  Stack,
} from "@mui/material";

const TitleTypography = styled(Typography)(({ theme }) => ({
  margin: 0,
  color: theme.palette.primary.main,
  fontWeight: theme.typography.customFontWeight[2],
  fontSize: theme.typography.customFontSize[3],
}));

const ContentTypography = styled(Typography)(({ theme }) => ({
  margin: 0,
  color: theme.palette.primary.black,
  fontSize: theme.typography.customFontSize[2],
}));

const DhcpContent = ({ dhcpData }) => {
  const theme = useTheme();
  const columnFlex = [0.5, 1.5, 3.5, 1, 1];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: 560 }}>
      <Box width="100%" p="16px">
        <Card sx={{ p: 2 }}>
          <Stack
            direction="row"
            sx={{
              px: 1.5,
              pb: 1,
              borderBottom: `1px solid ${theme.palette.primary.borderGreyPrimary}`,
              mb: 2,
            }}
          >
            {["#", "Interface", "IP Range", "Lease", "Free"].map((item, index) => (
              <TitleTypography
                key={index}
                sx={{ flex: columnFlex[index] }}
              >
                {item}
              </TitleTypography>
            ))}
          </Stack>
          <List disablePadding>
            {dhcpData.map((item, index) => (
              <ListItem
                key={`dhcp-${index}`}
                divider
                sx={{
                  py: 1,
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "none",
                }}
              >
                <ContentTypography sx={{ flex: columnFlex[0] }}>
                  {index + 1}
                </ContentTypography>
                <ContentTypography sx={{ flex: columnFlex[1] }}>
                  {item.interfaceName}
                </ContentTypography>
                <ContentTypography sx={{ flex: columnFlex[2] }}>
                  {item.ipStart} - {item.ipEnd}
                </ContentTypography>
                <ContentTypography sx={{ flex: columnFlex[3] }}>
                  {item.lease}
                </ContentTypography>
                <ContentTypography sx={{ flex: columnFlex[4] }}>
                  {item.free}
                </ContentTypography>
              </ListItem>
            ))}
          </List>
        </Card>
      </Box>
    </Box>
  );
};

export default DhcpContent;
